// default expiry is 12h in milliseconds
export const setLocalStorageItem = (key: string, value: string, maxAge = 12 * 60 * 1000): void => {
  if (typeof window === 'undefined') return;

  // store the value as the object
  // along with the expiry date
  const result = {
    data: value,
    expireTime: 0,
  };

  if (maxAge) {
    // set the expiry
    // from the current date
    result.expireTime = Date.now() + maxAge;
  }

  // stringify the result
  // and the data in original storage
  window.localStorage.setItem(key, JSON.stringify(result));
};

export const getLocalStorageItem = (key: string): string | null => {
  if (typeof window === 'undefined') return null;
  if (!window.localStorage.getItem(key)) return null;

  // get the parsed value of the given key
  const result = JSON.parse(window.localStorage.getItem(key) || '');

  // if the key has value
  if (result) {
    // if the entry is expired
    // remove the entry and return null
    if (result.expireTime <= Date.now()) {
      window.localStorage.removeItem(key);
      return null;
    }

    // else return the value
    return result.data;
  }

  // if the key does not have value
  return null;
};
